import React, { createContext, useContext, useMemo, useState } from 'react';

const CorporateNavContext = createContext(null);

export function CorporateNavProvider({ children }) {
  const [workspaceNav, setWorkspaceNav] = useState(null);

  const value = useMemo(
    () => ({
      workspaceNav,
      setWorkspaceNav,
    }),
    [workspaceNav],
  );

  return (
    <CorporateNavContext.Provider value={value}>{children}</CorporateNavContext.Provider>
  );
}

export function useCorporateNav() {
  return useContext(CorporateNavContext);
}
